import React from "react";
import { InfiniteScroll } from "../../nq-component";
import BasePage from "../../base/BasePage";
import PageHeader from "../../components/PageHeader";
import withRouter from "../../withRouter";
import SettingsFormPage from "./form/SettingsFormPage";

class SystemSettingsPage extends BasePage {
  render() {
    return (
      <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
        <div className="d-flex flex-column gap-4">
          <PageHeader
            breadcrumb={[
              { label: "Home", path: "/" },
              { label: "Settings", path: "/settings" },
              { label: "System Settings" },
            ]}
            title="System Settings"
            backButton
            list={true}
            description="Configure application-wide preferences and behavior"
          />

          <div
            className="bg-white rounded-3 shadow-sm"
            style={{ border: "1px solid #e9ecef" }}
          >
            <SettingsFormPage />
          </div>
        </div>
      </InfiniteScroll>
    );
  }
}

export default withRouter(SystemSettingsPage);
